module.exports = __webpack_public_path__ + "static/media/namibia-shipping-map.7700257e.jpg";